/* eslint-disable */
export default function initMenu() {
  document.querySelectorAll('.js-clone-menu').forEach((menu) => {
    const cloneHolders = document.querySelectorAll('.js-clone-menu-holder');
    const menuOpeners = document.querySelectorAll('.js-burger-opener');
    const openedClass = 'menu-opened';
    const body = document.querySelector('body');

    menuOpeners.forEach((menuOpener) => {
      menuOpener.addEventListener('click', (e) => {
        e.preventDefault();
        body.classList.toggle(openedClass);
      });
    });

    const activeLi = menu.querySelector('li.active');

    let activeIndex;

    if (activeLi) {
      activeIndex = Array.from(activeLi.parentNode.children).indexOf(activeLi);
    }

    function setupNav(nav) {
      const menuLinks = nav.querySelectorAll('a[href^="#"]:not([href="#"]),a[href^="#"]:not([href="#popup-"])');
      const sections = document.querySelectorAll('section[id]');

      if (activeLi) {
        nav.style.setProperty('--i', activeIndex);
      }

      function updateActiveSection() {
        let closestSection = null;
        let minDistance = Infinity;
        const viewportCenter = window.innerHeight / 2;

        sections.forEach((section) => {
          const rect = section.getBoundingClientRect();
          const sectionCenter = rect.top + rect.height / 2;
          const distance = Math.abs(viewportCenter - sectionCenter);

          if (distance < minDistance) {
            minDistance = distance;
            closestSection = section;
          }
        });

        if (closestSection) {
          const id = closestSection.getAttribute('id');
          const links = Array.from(menuLinks).filter((a) => a.getAttribute('href') === `#${id}`);

          if (!links.length) return;

          menuLinks.forEach((link) => link.classList.remove('active'));
          links.forEach((link) => link.classList.add('active'));

          const parentLi = links.length > 0 ? links[0].closest('li') : null;
          if (parentLi) {
            activeIndex = Array.from(parentLi.parentNode.children).indexOf(parentLi);
            nav.style.setProperty('--i', activeIndex);
          }
        }
      }

      window.addEventListener('scroll', updateActiveSection);
      window.addEventListener('resize', updateActiveSection);
      updateActiveSection();
    }

    document.querySelectorAll('.js-clone-menu nav ul').forEach(setupNav);

    cloneHolders.forEach((holder) => {
      const clonedMenu = menu.cloneNode(true);
      const cloneTarget = holder;
      cloneTarget.innerHTML = '';
      cloneTarget.appendChild(clonedMenu);
      clonedMenu.querySelectorAll('nav ul').forEach(setupNav);
    });

    function syncMenus(targetLi, isOpen) {
      const targetText = targetLi.querySelector('a') ? targetLi.querySelector('a').innerText.trim() : '';

      document.querySelectorAll('.js-clone-menu-holder li, .nav li').forEach((cloneLi) => {
        const cloneText = cloneLi.querySelector('a') ? cloneLi.querySelector('a').innerText.trim() : '';
        if (cloneText === targetText) {
          cloneLi.classList.toggle('opened', isOpen);
        }
      });
    }

    let prevOpenLi = null;

    // Add the missing updateTopPosition function
    function updateTopPosition() {
      const openedLi = document.querySelector('.nav li.opened, .js-clone-menu-holder li.opened');
      if (openedLi) {
        const submenu = openedLi.querySelector('ul');
        const submenuHeight = submenu.scrollHeight;
        const offsetTop = openedLi.offsetTop;
        document.documentElement.style.setProperty('--activeHeight', `${submenuHeight}px`);
        document.documentElement.style.setProperty('--activeOffset', `${offsetTop}px`);
      } else {
        document.documentElement.style.setProperty('--activeHeight', '0px');
        document.documentElement.style.setProperty('--activeOffset', '0px');
      }
    }

    document.querySelectorAll('.nav a:not(:only-child), .js-clone-menu-holder a:not(:only-child)').forEach((menuLink) => {
      const openClass = 'opened';

      menuLink.addEventListener('click', (e) => {
        e.preventDefault();

        const parentLi = menuLink.closest('li');
        const submenu = parentLi.querySelector('ul');

        if (submenu) {
          const isOpen = parentLi.classList.toggle(openClass);

          if (prevOpenLi && prevOpenLi !== parentLi) {
            prevOpenLi.classList.remove(openClass);
            syncMenus(prevOpenLi, false);
          }

          if (isOpen) {
            setTimeout(() => {
              const submenuHeight = submenu.scrollHeight;
              const { offsetTop } = parentLi;
              document.documentElement.style.setProperty('--activeHeight', `${submenuHeight}px`);
              document.documentElement.style.setProperty('--activeOffset', `${offsetTop}px`);
              prevOpenLi = parentLi;
              updateTopPosition();
            }, 300);
          } else {
            prevOpenLi = null;
            updateTopPosition();
          }

          syncMenus(parentLi, isOpen);
        }
      });
    });
  });
}
